export function isSuperset(set, subset) {
  if (subset.size === 0) return false;
  for (const elem of subset) {
    if (!set.has(elem)) {
      return false;
    }
  }
  return true;
}
